import cloudinaryTemplate from './cloudinary_image.template.html?raw';
import cloudinaryBindings from './cloudinary_image.bindings.js';
import cloudinaryController from './cloudinary_image.controller.js';

const cloudinaryImage = {
  templateUrl: cloudinaryTemplate,
  bindings: cloudinaryBindings,
  controllerAs: 'vm',
  controller: cloudinaryController,
  transclude: true
};

export default angular
  .module('components.cloudinaryImage', [])
  .run([
    '$templateCache',
    $templateCache => {
      $templateCache.put(cloudinaryTemplate, cloudinaryTemplate);
    }
  ])
  .component('cloudinaryImage', cloudinaryImage);
